import styled from 'styled-components'
import PlaceHolder from 'Components/PlaceHolder'
import { NoMarginRow } from 'Components/EnhacedFlexboxGrid'
import { IS_MRLOFT } from 'Config/config'
import Spinner from 'Components/Spinner'
import { BREAK_POINT_MD, BREAK_POINT_LG } from '@CSSVars/variables'
import {
  GREY_BACKGROUND,
  OUTLINE_COLOR,
  HYPER_LINK_COLOR,
  WHITE_OUTLINE_COLOR,
  PRIMARY_SECTION_BG_COLOR,
  PRIMARY_DARK_COLOR,
  LINK_COLOR,
  SELECTED_ITEM_BG_COLOR,
  PRIMARY_NORMAL_COLOR,
  FONT_BASE_COLOR,
  FAV_AREA_BG_COLOR,
} from '@CSSVars/colors'

const BLOCKS_MARGIN_TOP_767 = '20px'

export const _BuildingInfoWrapper = styled.div`
  width: 34%;
  height: 100%;
  display: flex;
  position: absolute;
  left: 0;
  top: 0;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    width: 43%;
  }
  @media screen and (max-width: 900px) {
    width: 54%;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
    position: relative;
  }
`

export const _BuildingInfo = styled.div`
  ${({ isPrecon }) =>
    (isPrecon
      ? `
     margin-top: 32px;
     display: flex;
     flex-direction: column;
     justify-content: space-between;

    `
      : `
    margin: 32px 24px 0 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    `)};

  width: 100%;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    margin-top: 24px;
  }
`

export const _BuildingTitleContainer = styled.div`
  min-height: 34px;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  max-width: 90%;
  overflow: hidden;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    min-height: initial;
    justify-content: flex-start;
    ${_BuildingInfo} & {
      height: auto;
    }
  }
`

export const _BuildingInfoInner = styled.div`
  ${({ isPrecon }) =>
    (isPrecon
      ? `
     padding: 0 27px

    `
      : `
   padding: 0;
    `)};
  @media screen and (max-width: 1023px) {
    margin-top: 0;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`
export const _PreconStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

export const _AdminButtons = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  top: 18px;
  right: 24px;
  > div {
    margin-right: 10px;
  }
  svg {
    path {
      fill: ${FONT_BASE_COLOR};
    }
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    top: 8px;
  }
`

export const _Link = styled.div`
  color: ${PRIMARY_DARK_COLOR};
`

export const _Title = styled.h1`
  font-size: 28px;
  font-family: var(--secondary-font);
  font-weight: 600;
  line-height: 34px;
  color: ${FONT_BASE_COLOR};
  letter-spacing: 0.01em;
  word-wrap: break-word;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    font-weight: 500;
    text-align: center;
  }
`

export const _Developer = styled.div`
  line-height: 17px;
  font-size: 14px;
  font-weight: 500;
  color: ${PRIMARY_DARK_COLOR};
  a {
    color: ${PRIMARY_DARK_COLOR};
    text-decoration: underline;
  }
  margin-top: 12px;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    padding-top: 6px;
    text-align: center;
  }
`

export const _Architect = styled(_Developer)`
  a {
    color: ${PRIMARY_DARK_COLOR};
    text-decoration: underline;
  }

  span {
    color: ${FONT_BASE_COLOR};
  }
`

export const _AddressDeveloperContainer = styled.div`
  margin: 12px 0 auto 0;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    ${_BuildingInfo} & {
      height: auto;
      margin: 6px 0 24px 0;
    }
  }
`

export const _MarkerWithAddress = styled.div`
  display: flex;
  align-items: center;
  h1,
  h2 {
    color: ${FONT_BASE_COLOR};
    width: 100%;
    font-family: var(--secondary-font);
    word-break: break-word;
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    text-align: left;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    max-height: initial;
    margin: 6px 0;
  }
`

export const _SaleRentCountBlocks = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const _SaleRentBlock = styled.div`
  width: 100%;
  height: 48px;
  position: relative;
  background: white;
  border: 1px solid ${OUTLINE_COLOR};
  display: flex;
  justify-content: center;
  border-radius: 10px;
  &:hover {
    cursor: pointer;
  }
  &:first-child {
    margin-bottom: 12px;
  }
  @media (hover: hover) {
    :hover {
      background: ${LINK_COLOR};
      border: 1px solid ${LINK_COLOR};
      div {
        color: white;
      }
    }
  }
  :active {
    background: ${SELECTED_ITEM_BG_COLOR};
    border: 1px solid ${SELECTED_ITEM_BG_COLOR};
    color: white;
    div {
      color: white;
    }
  }
`

export const _ButtonTextContainer = styled(NoMarginRow)`
  align-items: center;
`

export const _ButtonText = styled.div`
  color: ${FONT_BASE_COLOR};
  font-size: 14px;
  letter-spacing: 0.01em;
  line-height: 22px;
  font-weight: 500;
`

export const _FloorPlanBlocks = styled(_SaleRentBlock)`
  height: 90px !important;
  margin: 0 !important;
  align-items: center;
  width: 100% !important;
  border: 1px solid ${OUTLINE_COLOR};
  border-bottom: none;
  svg {
    margin-right: 10px;
  }
  @media screen and (max-width: 1023px) {
    height: 100px;
  }
  @media screen and (max-width: 767px) {
    background: ${GREY_BACKGROUND};
    margin-top: ${BLOCKS_MARGIN_TOP_767} !important;
  }
`

export const _FloorPlan = styled.div`
  ${_FloorPlanBlocks} & {
    span {
      padding-left: 0.5rem;
      font-size: 18px;
      color: ${HYPER_LINK_COLOR};
    }
  }
`

export const _TextBoxContainer = styled.div`
  height: 100px;
  padding: 18px;
  border-radius: 10px;
  background: ${PRIMARY_SECTION_BG_COLOR};
  &:hover {
    cursor: pointer;
  }
  @media screen and (max-width: 1023px) {
    height: 115px;
    &:hover {
      cursor: pointer;
    }
  }
  @media screen and (max-width: 767px) {
    height: auto;
  }
`

export const _TextBoxInner = styled.div`
  height: 100%;
  line-height: 22px;
  color: white;
`

export const _Count = styled.div`
  color: ${PRIMARY_DARK_COLOR};
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0.01em;
  text-align: center;
`

export const _AnchorText = styled.a`
  margin: 0 10px;
  cursor: pointer;
  text-align: center;
  line-height: 26px;
  letter-spacing: 0.01em;
  min-width: 112px;
  white-space: nowrap;
  color: ${PRIMARY_DARK_COLOR};
  &:first-child {
    text-align: right;
  }
  @media (hover: hover) {
    :hover {
      color: ${PRIMARY_NORMAL_COLOR};
    }
  }
  :active {
    color: ${SELECTED_ITEM_BG_COLOR};
  }
`

export const _AnchorContainer = styled.div`
  display: flex;
  color: white;
  margin: 0 auto;
`

export const _AnchorDivider = styled.span`
  color: ${OUTLINE_COLOR};
  line-height: 26px;
  letter-spacing: 0.01em;
`

export const _SvgAnchorContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin: 24px 0px;
  justify-content: center;
`

export const _TitlePlaceHolder = styled(PlaceHolder)`
  height: 30px;
  @media screen and (max-width: 1023px) {
    max-width: 50%;
  }
`

export const _AddressPlaceHolder = styled(PlaceHolder)`
  @media screen and (max-width: 1023px) {
    max-width: 30%;
  }
`

export const _Spinner = styled(Spinner)`
  > div {
    margin-left: 5px;
    width: 20px;
    height: 20px;
    background-size: 20px 20px;
  }
`

export const _Container = styled.div`
  border-radius: 10px;
  border: 1px solid ${WHITE_OUTLINE_COLOR};
`
export const _ContactAgentContainer = styled.div`
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: none;
  }
`
export const _PreconContainer = styled.div`
  padding: 0 27px;
`

export const _PreconStatus = styled.div`
  text-transform: capitalize;
  font-size: 24px;
  font-weight: 600;
  line-height: 38px;
  text-align: left;
  margin-bottom: 12px;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    font-size: 18px;
    line-height: 22px;
  }
`
export const _PreconPriceRange = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  text-align: left;
  margin-bottom: 32px;
`
export const _PreconSubtext = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
  margin-bottom: 12px;
  span {
    font-weight: 600;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    font-size: 14px;
    text-align: center !important;
  }
`
export const _PreconConstructionStatus = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
  margin-bottom: 12px;
  span {
    font-size: 12px;
    line-height: 14px;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
    margin-bottom: 14px;
    span {
      display: none;
    }
  }
`
export const _PreconRequestInfo = styled.div`
  background: ${IS_MRLOFT ? 'rgba(191, 60, 72, 0.1)' : FAV_AREA_BG_COLOR};
  border-bottom-left-radius: 10px;
  padding: 9px 20px 0 24px;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    padding: 16px 16px 8px 16px;
    margin: 48px 24px 0 24px;
    border-radius: 10px;
  }
`

export const _RequestInfoText = styled.div`
  ${({ isBold }) =>
    (isBold
      ? `
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
    `
      : `
      font-size: 14px;
      font-weight: 500;
      line-height: 26px;
    `)};
  margin: 12px 0 0 0;
`

export const _MiddleSection = styled.div`
  margin-bottom: 32px;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: flex;
    ${({ isPrecon }) =>
    (isPrecon
      ? `
      flex-direction: row;
          margin-bottom: 20px;
      `
      : `
      flex-direction: column;
      margin-bottom: 0;
      `)};

    justify-content: center;
  }
`

export const _PreconTag = styled.div`
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.63px;
  padding: 3px 9px;
  color: white;
  background: ${PRIMARY_DARK_COLOR};
  border-radius: 4px;
  width: fit-content;
  margin-bottom: 12px;
  ${({ isPrecon }) =>
    (isPrecon
      ? `
    `
      : `
      display: none;
    `)};
`
